
import initVideoEmbedPlayers from "Modules/VideoEmbedPlayer/VideoEmbedManager";

// API
export default {
  initVideoEmbedPlayers: initVideoEmbedPlayers
}